// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605111026/js/" + chunkId + "." + {"44":"8694c724","225":"5f7d9765","481":"c1f879c1","486":"3aed4a68","770":"3bfcc34e"}[chunkId] + ".0.611829759435564.chunk.js";
};